import List from "../../layout/List/List";
import styles from "./OurServicesMain.module.scss";

const services = [
  {
    title: "Nieruchomość",
    list: [
      "Kupno i sprzedaż nieruchomości",
      "Wycena i wycena cen nieruchomości",
      "Zarządzanie nieruchomościami",
      "Wynajem apartamentów i związane z tym usługi (sprzątanie, zmiana, podlewanie kwiatów i inne)",
      "Reprezentacja wynajmującego",
      "Reprezentacja najemcy",
      "Organizujemy zakup gruntów, usługi inżynieryjne",
      "Realizacja projektu",
      "Podatki od nieruchomości",
    ],
  },
  {
    title: "Transport i zakwaterowanie",
    list: [
      "Zapewniamy bezpłatny transfer z i na lotnisko, a także bezpłatny nocleg dla 2-4 osób podczas przeglądania naszych ofert dla klientów, którzy dokonali przedpłaty przy zakupie apartamentu.",
      "Transfer",
      "Zapewnimy Ci rejestrację samochodu w urzędzie",
      "Wypożyczalnia samochodów",
      "Cumowanie statków",
    ],
  },
  {
    title: "Biznes i finanse",
    list: [
      "Pomoc w prowadzeniu działalności gospodarczej w dowolnej dziedzinie biznesu",
      "Oferujemy otwieranie spółek w Bułgarii i innych krajach wraz z pełną obsługą prawną",
      "Oferujemy otwarcie konta w dowolnym banku",
      "Usługi finansowe, kredyty bankowe, korzystne finansowanie prywatne wniektórych obszarach",
      "Usługi inwestycyjne",
    ],
  },
  {
    title: "Obsługa prawna",
    list: [
      "Usługi prawne i notarialne",
      "Usługi tłumaczeniowe",
      "Ubezpieczenia majątkowe",
      "Obsługa prawna",
    ],
  },
  {
    title: "Budowa i remont",
    list: [
      "Usługi rzemieślnicze i budowlane",
      "Przebudowa mieszkania",
      "Roboty budowlane",
      "Drobne prace",
      "Stolarstwo",
      "Plany",
    ],
  },
  {
    title: "Inne usługi",
    list: [
      "Zorganizujemy dla Ciebie stałe lub czasowe zakwaterowanie w Twoim mieszkaniu",
      "Dostarczanie elektryczności i wody",
      "Klimatyzacja",
      "Rolety i żaluzje",
      "Centrum fitness w Słonecznym Brzegu w Bułgarii z sauną, łaźnią parową, jacuzzi, strefą relaksu, gabinetem masażu, organizujemy zajęcia grupowe, spinning, boks, całoroczną pracę w luksusowym kompleksie Emilia Romana Este",
    ],
  },
];

const OurServicesMain = () => {
  return (
    <>
      <section className={styles.ourServicesMain}>        
          <h2 className={`${styles.ourServicesMain__title} titleH2`}>
            Możemy Ci pomóc w każdym kraju.{" "}
          </h2>
          <h4 className={styles.ourServicesMain__subtitle}>
            Pomożemy Ci, nawet jeśli nie kupiłeś u nas nieruchomosci. <br />A w
            jakich obszarach możemy Ci pomóc?
          </h4>        
        <div className={styles.ourServicesMain__list}>
          {services.map((item, index) => (
            <List title={item.title} list={item.list} key={index} />
          ))}
        </div>
      </section>
    </>
  );
};

export default OurServicesMain;
